export type ConversationStartersContext =
  | { type: 'recruitment_general' }
  | {
      type: 'recruitment_candidate';
      params: { candidateId: number; candidateName: string };
    };

export interface ConversationStarter {
  id: string;
  source: string;
  definitionKey: string;
  skill: string | null;
  text: string;
  message: string;
  priority: number;
}

export interface ConversationStarters {
  type: ConversationStartersContext['type'];
  prompt: string;
  conversationStarters: readonly ConversationStarter[];
}

export const conversationStartersKey = (ctx: ConversationStartersContext): string =>
  ctx.type === 'recruitment_candidate' ? `${ctx.type}:${ctx.params.candidateId}` : ctx.type;
